import React from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { addToHistory } from 'src/utils/utilsActions';

import { PageTitle } from 'src/ui/library/PageTitle';
import {
  getUserInfoSelector,
  isCorpClientSelector,
  isApplicantSelector,
  isRestrictedCorpMemberSelector,
} from '../../../../ui/features/Login/state/loginReselect';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import EmployeeHeader from 'src/new-ui/features/EmployeeHeader';
import CaseComponentContainer from './CaseComponentContainer';

const useStyles = color => ({
  switch: {
    '& .Mui-checked': {
      color: '#FFFF00',
    },
    '& .MuiSwitch-track': {
      backgroundColor: '#FFFF00 !important',
    },
    position: 'fixed',
    zIndex: '200',
    marginTop: '267px',
  },
  formControlLabel: {
    color: '#FFFF',
  },
  containerSpacing: {
    padding: '10px',
  },
  caseStyle: {
    marginTop: '84px !important',
    // position: 'fixed',
    // zIndex: '100',
    display: 'flex',
  },
});

// const caseIdStyle = {
//     marginTop: '84px !important',
//     position: 'fixed',
//     zIndex: '100',
// }

class NewDashboardContainer extends React.Component {
  componentDidMount() {
    this.isShowToggle = (process.env.SHOW_DASHBOARD_TOGGLE_ENV || 'false').toLowerCase() === 'true' ? true : false;
    const { addToHistory } = this.props;
    addToHistory(window.location.pathname);
  }
  componentWillUnmount() {}
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <PageTitle title={'New ' + intl.get('dashboard.pageTitle')} />

        <Grid container>
          <Grid>
            <EmployeeHeader isCorpClient={this.props.isCorpClient} userDetails={this.props.userInfo} history={this.props.history} />
          </Grid>
        </Grid>
        <Grid container className={classes.caseStyle}>
          <CaseComponentContainer history={this.props.history} isCorp={this.props.isCorpClient} />
        </Grid>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    isTablet: state.browser.greaterThan.small && state.browser.is.medium,
    isMobile: state.browser.is.small || state.browser.is.extraSmall,
    userInfo: getUserInfoSelector(state),
    userId: state.dashboard.userId,
    isCorpClient: isCorpClientSelector(state),
    isApplicant: isApplicantSelector(state),
    isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
    headerCount: state.dashboard.headerCount,
    isAllData: state.dashboard.dashboardType === 'allData',
  };
};
const mapDispatchToProps = {
  addToHistory,
};
const dash = connect(mapStateToProps, mapDispatchToProps)(NewDashboardContainer);
export default withStyles(useStyles)(dash);
